import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type SchoolFilter } from '../types/filters';

export const founderPreviousSchoolDefinition: FilterDefinition<SchoolFilter> = {
  id: FilterId.FOUNDER_PREVIOUS_SCHOOL,
  name: 'Founder Previous School',
  type: FilterType.SCHOOL,
  schoolResultItems: {},
  isVisible: true,
};

export const founderPreviousSchoolHandler: FilterHandler<SchoolFilter> = {
  isActive(currentFilterState: SchoolFilter) {
    return Object.keys(currentFilterState.schoolResultItems).length > 0;
  },
  isDefault(currentFilterState: SchoolFilter) {
    return Object.keys(currentFilterState.schoolResultItems).length === 0;
  },
  getEffectiveFilter(currentFilterState: SchoolFilter) {
    return { ...currentFilterState };
  },
};
